import React from 'react';
import { Grid } from '@material-ui/core';
import { FullField } from 'components/CustomFields/CustomFields.jsx';
import NumberInput from 'components/Wrappers/materialUIWrappers/components/NumberInput';
import FormDropdown from 'components/Wrappers/materialUIWrappers/components/FormDropDown';
import { requiredDropdown, required } from 'helpers/ValidationHelpers';
import {
  ComprehensiveDisability,
  OwnOccupationDis,
  Impairment,
  getValidationCriteria,
  validateCriteria
} from '../BenifitCompanyValidation';
import CompanyErrorBlock from '../../components/CompanyErrorBlock';
import store from 'store';
import { get } from 'lodash';

const min100k = value => {
  if (value === undefined) return undefined;

  if (parseInt(value, 10) < 100000.0) {
    return 'Must be greater than R100 000';
  }
  return undefined;
};

class DisabilityLumpsum extends React.PureComponent {
  state = {
    companyCriteria: null,
    toAge: null
  };

  componentDidMount() {
    this.setValidationCriteria();
  }

  validateCoverAccelerator = value => 
  {
    const accelerator = get(
      store.getState().form.quotev2.values,
      'disabilityAccelerator',
      null
    );
    const lifeCoverAmount = get(
      store.getState().form.quotev2.values,
      'lumpSumCover',
      null
    );

    if (!value || !this.props.selectedBenefits.includes(3))
		{
			if(accelerator == '2')
				return "Life cover must be selected to be able to select accelerated benefits.";
			else
				return undefined;
		} 

    

    if (!accelerator || accelerator !== '2') return undefined;

    

    if (!lifeCoverAmount) return undefined;

    if (parseFloat(value) > parseFloat(lifeCoverAmount)) {
      return 'Cannot be more than Whole Life Cover Amount';
    }
    return undefined;
  };

  setValidationCriteria = () => {
    let premiumPattern = store.getState().form.quotev2.values.premiumPattern;
    const toAge = this.getToAge();

    let disabilityOption = get(
      store.getState().form.quotev2.values,
      'disabilityOption',
      'validationError'
    );

    let benefitValidationObj = ComprehensiveDisability;

    switch (disabilityOption) {
      case 'Occupational':
        benefitValidationObj = OwnOccupationDis;
        break;
      case 'Impairment':
        benefitValidationObj = Impairment;
        break;

      default:
        break;
    }

    const companyCriteria = getValidationCriteria({
      benefitValidationObj: benefitValidationObj,
      targets: this.props.AvailTargetsForBroker,
      selectedTargets: this.props.selectedTargets,
      occupation: this.props.occupation,
      qualification: this.props.qualification,
      premiumPattern: premiumPattern,
      age: this.props.clientAge,
      anualSalary: this.props.clientAnualSalary,
      toAge: toAge
    });
    this.setState({ companyCriteria: companyCriteria, toAge: toAge });

    return companyCriteria;
  };

  getToAge = () => {
    let toAge = get(
      store.getState().form.quotev2.values,
      'dCeaseAge',
      'validationError'
    );
    if (toAge === 'validationError') toAge = '70';
    return toAge;
  };

  render() {
    let disabilityOptions = [
      { value: 'validationError', displayValue: 'Please select' },
      { value: 'OccupationalC', displayValue: 'Comprehensive Own Occupation' },

      { value: 'Occupational', displayValue: 'Own Occupation' },
      {
        value: 'OccupationalOC',
        displayValue: 'Comprehensive  Own/ Similar Occupation'
      },
      { value: 'OccupationalO', displayValue: 'Own/ Similar Occupation' },

      { value: 'Impairment', displayValue: 'Impairment' }
    ];

    if (this.props.disOnlyImpairment) {
      disabilityOptions = disabilityOptions.filter(
        o => o.value === 'Impairment' || o.value === 'validationError'
      );
    }

    let companyErrors = {};

    if (this.state.companyCriteria) {
      let companyCriteria = { ...this.state.companyCriteria };

      if (this.getToAge() !== this.state.toAge) {
        companyCriteria = this.setValidationCriteria();
      }

      const lumpSumCover = get(
        store.getState().form.quotev2,
        'values.disabilityLumpsumCover',
        0
      );

      companyErrors = validateCriteria(
        companyCriteria,
        {
          amount: lumpSumCover,
          age: this.props.clientAge
        },
        100000.0
      );
    }

    const benefitValid = Object.keys(companyErrors).length < 1;
    this.props.setBenefitValidity(benefitValid);

    return (
      <Grid container>
        <FullField
          name={'disabilityLumpsumCover'}
          label={'Lumpsum cover *'}
          component={NumberInput}
          onChange={() => this.forceUpdate()}
          prefix='R'
          seperator=' '
          checkValidation={this.props.checkValidation}
          isrequired={true}
          validate={[required, min100k, this.validateCoverAccelerator]}
        />
        <FullField
          name={'disabilityAccelerator'}
          label={'Standalone or Accelerated *'}
          component={FormDropdown}
          onChange={() => this.forceUpdate()}
          checkValidation={this.props.checkValidation}
          isrequired={true}
          validate={[requiredDropdown]}
          options={[
            { value: 'validationError', displayValue: 'Please select' },
            { value: '1', displayValue: 'Standalone' },
            { value: '2', displayValue: 'Accelerator' }
          ]}
        />

        <FullField
          name={'disabilityTapering'}
          label={'Tapering/Non Tapering *'}
          component={FormDropdown}
          checkValidation={this.props.checkValidation}
          isrequired={true}
          validate={[requiredDropdown]}
          options={[
            { value: 'validationError', displayValue: 'Please select' },
            { value: 'Y', displayValue: 'Tapering' },
            { value: 'N', displayValue: 'Non Tapering' }
          ]}
        />

        <FullField
          name={'dCeaseAge'}
          label={'Cease age *'}
          component={FormDropdown}
          onChange={() => this.forceUpdate()}
          checkValidation={this.props.checkValidation}
          isrequired={true}
          validate={[requiredDropdown]}
          options={[
            { value: 'validationError', displayValue: 'Please select' },
            { value: '65', displayValue: '65' },
            { value: '70', displayValue: '70' }
          ]}
        />
        <FullField
          name={'disabilityOption'}
          label={'Disability option *'}
          component={FormDropdown}
          onChange={() => this.forceUpdate()}
          checkValidation={this.props.checkValidation}
          isrequired={true}
          validate={[requiredDropdown]}
          options={disabilityOptions}
        />

        {!benefitValid ? (
          <Grid item xs={12} sm={12} md={12}>
            <CompanyErrorBlock companyErrors={companyErrors} />
          </Grid>
        ) : null}
      </Grid>
    );
  }
}

export default DisabilityLumpsum;



// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/steps/BenefitQuestions/DisabilityLumpsum.jsx